export default __webpack_public_path__ + "static/media/Globe Life Dark.bba673c0.svg";